module.exports = __webpack_public_path__ + "static/media/Estampa_Card8.f5bc1e17.png";